import { store, storeFuns } from 'sw-hic'

storeFuns.init({})

export default store
